import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import Layout from "../components/Layout";
import Home from "../pages/Home";
import Trace from "../pages/Trace";
import Demo from "../pages/Demo";
import BlogIndex from "../pages/BlogIndex";
import BlogPost from "../pages/BlogPost";
import NewsIndex from "../pages/NewsIndex";
import NewsPost from "../pages/NewsPost";

// Recover is isolated in its own lazy chunk. This is a UX/build-hygiene
// measure, not the security boundary itself — the real guarantee (no network
// calls leave this module) is enforced by the test in
// tests/privacy-guarantees/ and by the module containing zero fetch/XHR/WS
// calls in its dependency tree. See SECURITY.md.
const Recover = lazy(() => import("../pages/Recover"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "recover",
        element: (
          <Suspense fallback={<div className="p-8 text-muted">Loading recovery module…</div>}>
            <Recover />
          </Suspense>
        ),
      },
      { path: "trace", element: <Trace /> },
      { path: "demo", element: <Demo /> },
      { path: "blog", element: <BlogIndex /> },
      { path: "blog/:slug", element: <BlogPost /> },
      { path: "news", element: <NewsIndex /> },
      { path: "news/:slug", element: <NewsPost /> },
    ],
  },
]);
